import axios from 'axios'
import vm from "../main";

const http_client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    header: {
        accept: 'application/json',
    },
    withCredentials: false,
});

let api = function() {
    let token = localStorage.getItem("delishcare-token");
    if (token) {
        http_client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return http_client;
};

api().interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401 || error.response.status === 403) {
            vm.$store.dispatch("authStore/logOut");
        }
        return Promise.reject(error);
    }
);

export const http = api;

export const apiVersion = ''
 